import { createContext, Dispatch, SetStateAction, useContext } from 'react';

interface CONTEXT {
  isEditMode?: boolean;
  selectedEventId?: string | null;
  setIsEditMode?: Dispatch<SetStateAction<boolean>>;
  clearTaskId?: () => void;
  setSelectedEventId?: Dispatch<SetStateAction<string | null>>;
}

const EventContext = createContext<CONTEXT>({});

export const useEventContext = () => useContext(EventContext);

export default EventContext;
